"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = require("../data/constants");
var abstractComponent_1 = __importDefault(require("./abstractComponent"));
var QuickMessageAnniversary = /** @class */ (function (_super) {
    __extends(QuickMessageAnniversary, _super);
    function QuickMessageAnniversary() {
        var _this = _super.call(this, constants_1.DATA_QUICK_MESSAGE_ANNIVERSARY) || this;
        if (!_this.getElement()) {
            return _this;
        }
        _this.quickMessageAnniversary = _this.getElement();
        _this.quickMessageCloseAnniversary = _this.getChildElement("[".concat(constants_1.DATA_QUICK_MESSAGE_CLOSE_ANNIVERSARY, "]"));
        _this.header = document.querySelector("[".concat(constants_1.DATA_HEADER, "]"));
        _this.mainNav = document.querySelector("[".concat(constants_1.DATA_MAIN_NAV, "]"));
        _this.maskFirstElement = document.querySelector('.section');
        _this.checkQuickMessageStatus();
        _this.getHeightOfQuickMessage();
        return _this;
    }
    /**
     *
     */
    QuickMessageAnniversary.prototype.checkQuickMessageStatus = function () {
        var now = parseInt(Date.now().toString().slice(0, 10));
        var lastChange = parseInt(this.quickMessageAnniversary.getAttribute('data-quick-message-anniversary'));
        var endDate = parseInt(this.quickMessageAnniversary.getAttribute('data-quick-message-anniversary-end'));
        var cookieValue = this.getCookieValue();
        if (now < endDate && (!cookieValue || cookieValue < lastChange)) {
            this.quickMessageAnniversary.classList.add('active');
            this.mainNav.classList.add('extra-height');
        }
        if (endDate < now) {
            this.deleteCookie('quickMessageAnniversary');
            this.mainNav.classList.remove('extra-height');
        }
        this.closeQuickMessage(lastChange);
        this.getCookieValue();
    };
    /**
     * Delay function
     * @param time - dleay time,
     */
    QuickMessageAnniversary.prototype.delay = function (time) {
        return new Promise(function (resolve) { return setTimeout(resolve, time); });
    };
    /**
     * Getting the height of the QuickMessage and adding margin-top to mask first element
     *
     */
    QuickMessageAnniversary.prototype.getHeightOfQuickMessage = function () {
        if (!this.getCookieValue()) {
            //setTimeout(() => {
            var headerHeight = this.header.clientHeight;
            if (this.maskFirstElement) {
                this.maskFirstElement.style.marginTop = "".concat(headerHeight, "px");
            }
            //}, 100);
        }
    };
    /**
     *
     */
    QuickMessageAnniversary.prototype.setCookie = function (lastChange) {
        document.cookie = 'quickMessageAnniversary=' + lastChange + '; path=/';
    };
    /**
     *
     */
    QuickMessageAnniversary.prototype.getCookieValue = function () {
        if (document.cookie.indexOf('quickMessageAnniversary=') != -1) {
            var cookieDate = ('; ' + document.cookie).split('; quickMessageAnniversary=').pop().split(';')[0];
            return parseInt(cookieDate);
        }
    };
    /**
     *
     */
    QuickMessageAnniversary.prototype.deleteCookie = function (name) {
        var date = new Date();
        // Set it expire in -1 days
        date.setTime(date.getTime() + (-1 * 24 * 60 * 60 * 1000));
        // Set it
        document.cookie = name + '=; expires=' + date.toUTCString() + '; path=/';
    };
    /**
     * Close Quick Message
     */
    QuickMessageAnniversary.prototype.closeQuickMessage = function (lastChange) {
        var _this = this;
        this.quickMessageCloseAnniversary.addEventListener('click', function () {
            if (_this.maskFirstElement) {
                _this.maskFirstElement.removeAttribute('style');
            }
            _this.quickMessageAnniversary.classList.remove('active');
            _this.setCookie(lastChange);
        });
    };
    return QuickMessageAnniversary;
}(abstractComponent_1.default));
exports.default = QuickMessageAnniversary;
